// @flow

import type { FullState } from '../../../types';
import type { IDNLanguages } from '../../types';

export const select = (state: FullState): IDNLanguages =>
  state.domainSuggest.idn;
